import { render, staticRenderFns } from "./LandingWeddingES.vue?vue&type=template&id=67a46982&scoped=true"
import script from "./LandingWeddingES.vue?vue&type=script&lang=js"
export * from "./LandingWeddingES.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a46982",
  null
  
)

export default component.exports